import * as Logger from '../libs/wa-logger';
import {Carousel, ImageDetails} from './carousel';
import * as Guards from '../libs/guards'
// const $ = require('jquery');

// type ImageDetails = {
// 	imgObj : HTMLImageElement,
// 	parent: HTMLDivElement,
// 	otherImages : HTMLCollection,
// 	src : string,
// 	width : string,
// 	height : string,
// };
/**
 * This function starts the banner iimages on a page cycling if the page has a banner.
 * Steps:
 * 	1.	pages has banner if div with is #banner exists and selector #banner > img returns 
 * 		a non empty collection, in which case do the remainder of the steps
 * 2.	apend html (given below in addHtml() function) to the div.#banner element
 * 3. 	start cycling through the images (#banner > img) by showing them one at a time 
 * 		in the #banner-visible-div > img.#banner-img by updating the src attribute of 
 * 		#banner-img. 
 * 4.	The size of the displayed banner image is carried on each of the #banner > img elements,
 * 		and on the div.#banner element as data-width and data-height attributes. These are currently not used.
 * @param id_selector 
 */
export default function Banner(id_selector: string = "#banner") {
	let banner_images: ImageDetails[] = [];
	let carousel: Carousel;
	let banner_el: HTMLDivElement;

	const wait_for_images_to_load = true
	if(id_selector[0] == '#') {
		id_selector = id_selector.slice(1)
	} else {
		throw new Error("selector must be element id")
	}
	const b_el_tmp = document.getElementById(id_selector)
	if(!b_el_tmp) {
		Logger.log('Banner: no banner found on page - nothing to do')
		return
	} 
	const b_el = Guards.isHTMLDiv(b_el_tmp)
	const width = b_el.getAttribute('data-width')
	const height = b_el.getAttribute('data-height')
	banner_el = b_el
	if (width === undefined || height === undefined) {
		Logger.log('Banner: no h/w given for banner image');
		throw new Error('Banner: no h/w given for banner image');
	}

	const b_imgs = b_el.querySelectorAll(':scope > img')

	const number_imgs = b_imgs.length
	if (b_imgs.length <= 0) {
		Logger.log('Banner: no images found in banner');
		throw new Error('Banner: no images found in banner');
	}
	if(wait_for_images_to_load) {
		b_imgs.forEach((el) => {
			const image_el = Guards.isHTMLImage(el)
			console.log(["on image load", image_el, image_el.complete, image_el.naturalWidth])
			addImage(image_el)
		})
	}
	function addImage (el: HTMLImageElement) {
		const img_detail: ImageDetails = {
			imgObj : el,
			parent: Guards.isHTMLDiv(el.parentNode),
			otherImages : el.parentNode.children,
			src : el.getAttribute('src'),
			width : el.getAttribute('data-width'),
			height : el.getAttribute('data-height'),
		};
		banner_images.push(img_detail);
		el.style.display = 'none'
		if(b_imgs.length == banner_images.length) {
			Logger.writeln(`Banner::addImages starting carousel`)
			start_carousel_new()
		}
	}
	function addBannerHtml() {
		banner_el.innerHTML = banner_el.innerHTML + `
			<div id='banner-visible-div' class='row'>
				<img id='banner-img' class='' style="display:none; width:100%; height:auto;"/>
			</div>
		`
		banner_el.style.display = 'block'
		return Guards.isHTMLImage(banner_el.querySelector('#banner-img'))

	}
	function start_carousel_new() {
		const target = addBannerHtml()
		carousel = new Carousel(banner_images, target)
		carousel.render();
	}
};
